import Bugsnag from '@bugsnag/js';
import { useExpertServiceLazyQuery } from '../../../graph';

const OTHER_DESIGN_SERVICE_MPV_ID = 'otherDesign';

export type ResolveServiceProductMpvIdParams = {
    printProductMpvId: string | undefined;
};

export function useResolveServiceProductMpvId() {
    const [fetchExpertService] = useExpertServiceLazyQuery();

    return async function resolveServiceProductMpvId({
        printProductMpvId,
    }: ResolveServiceProductMpvIdParams): Promise<string> {
        if (!printProductMpvId) {
            return OTHER_DESIGN_SERVICE_MPV_ID;
        }

        const { data, error } = await fetchExpertService({
            variables: { mpvId: printProductMpvId },
        });
        if (error) {
            Bugsnag.notify(
                new Error(
                    `Error fetching expert service for print product mpvId ${printProductMpvId}: ${error.message}`
                )
            );
        }
        const resolvedMpvId = data?.expertService?.serviceProduct?.mpvId;
        if (resolvedMpvId) {
            return resolvedMpvId;
        }

        return OTHER_DESIGN_SERVICE_MPV_ID;
    };
}
